export default {
  category: Object.freeze({
    OWN_COMPLEXES: 'own-complexes', DENTAL_LAB_COMPLEXES: 'dental-lab-complexes',
    OWN_COMPLEXES_LABEL: 'Наши комплексы', DENTAL_LAB_COMPLEXES_LABEL: 'Зуботехническая лаборатория'
  }),
}
